import styled from 'styled-components'

import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import { ChessGridBackground } from 'styles/consts'
import { AiGenerationLoadingContent } from 'components/AIGenerationLoadingContent'
import {
  normalizeAndConvertAspectRatioForCSS,
  SQUARE_ASPECT_RATIO
} from 'utils/aspectRatio'

export const VideoItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background: ${COLORS.white};
  border-bottom: 1px solid ${COLORS.borderColor};

  &:last-child {
    border-bottom: none;
  }
`

export const VideoWrapper = styled.div<{ $aspectRatio: string }>`
  position: relative;
  width: 100%;
  aspect-ratio: ${({ $aspectRatio }) =>
    normalizeAndConvertAspectRatioForCSS($aspectRatio)};
  background: ${COLORS.secondaryUltraLight};
  border-radius: 8px;
  overflow: hidden;

  ${ChessGridBackground}
`

export const VideoElement = styled.video<{
  $isLoading: boolean
  $aspectRatio: string
}>`
  width: 100%;
  height: 100%;
  // we use 'cover' for other aspect ratios because media dimensions may not match
  // the aspect ratio, so we need to fill the container properly.
  object-fit: ${({ $aspectRatio }) =>
    $aspectRatio === SQUARE_ASPECT_RATIO ? 'contain' : 'cover'};
  opacity: ${props => (props.$isLoading ? 0 : 1)};
  transition: opacity 0.3s ease;
`

export const VideoPlaceHolder = styled.div`
  width: 100%;
  height: 100%;
`

export const MuteToggleButton = styled.button`
  position: absolute;
  bottom: 8px;
  right: 8px;
  z-index: 3;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid ${COLORS.secondarySemiLight};
  border-radius: 4px;
  background-color: ${COLORS.white};
  cursor: pointer;
  padding: 0;

  opacity: 0;
  transition:
    opacity 0.2s ease-in-out,
    border-color 0.2s ease-in-out,
    background-color 0.2s ease-in-out;

  ${VideoWrapper}:hover & {
    opacity: 1;
  }

  & > svg {
    width: 16px;
    height: 16px;
    fill: ${COLORS.secondarySemiDark};
  }

  &:hover {
    border-color: ${COLORS.secondary};
    background-color: ${COLORS.primaryLight};
    & > svg {
      fill: ${COLORS.secondaryDark};
    }
  }

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    opacity: 1;
  }
`

export const LoadingWrapper = styled(AiGenerationLoadingContent)`
  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    & > :first-child {
      width: 100% !important;
    }
  }
`
